import { jsx } from "react/jsx-runtime";
import { Link } from "pcln-design-system";
import { useContext } from "react";
import analytics from "../../analytics/analytics.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
import { useHandleLinkClick } from "../../hooks/useHandleLinkClick.js";
import { handleHotelRoomBookNowClick } from "../../HotelComponent/handleBookHotelClick.js";
import { FlightDetailLink } from "../FlightCompnents/FlightDetailLink.js";
import { InlineCitationLink } from "../MetadataMarker/InlineCitationLink.js";
import { InlineLocationLink } from "../MetadataMarker/InlineLocationLink.js";
import { RentalCarBookNowLink } from "../RentalCarComponent/RentalCarBookNowLink.js";
import { locationMetadataLinkClickHandler } from "./locationMetadataLinkClickHandler.js";
import { inlineMetadataManager } from "./MetadataManager.js";
const CustomLink = ({ children, href, onClick })=>{
    const { setIsMapOpened } = useChatUIContext();
    const { handleLinkClick } = useHandleLinkClick();
    const { submitChatMessagesPayload, requestFrom, isMobile } = useContext(ChatbotDataContext);
    const hotelPayload = submitChatMessagesPayload?.hotelPayload;
    try {
        const url = new URL(href);
        const type = url.searchParams.get('type');
        const webPageName = url.searchParams.get('webPageName');
        const citationNumber = url.searchParams.get('citationNumber');
        if ('CITATION' === type && webPageName && citationNumber) {
            const metadata = {
                name: '',
                type,
                citationNumber
            };
            return /*#__PURE__*/ jsx(InlineCitationLink, {
                metadata: metadata
            });
        }
        const name = url.searchParams.get('name');
        const lat = url.searchParams.get('lat');
        const lng = url.searchParams.get('lng');
        const hotelId = url.searchParams.get('hotelId');
        if (type && name && lat && lng) {
            const metadata = {
                name,
                type,
                lat: Number(lat),
                lng: Number(lng),
                hotelId
            };
            inlineMetadataManager.appendNewPinToList({
                singlePin: metadata,
                listOfPins: []
            });
            return /*#__PURE__*/ jsx(InlineLocationLink, {
                metadata: metadata,
                pinsInCurrentLine: [
                    metadata
                ],
                handleMapButtonClick: ()=>{
                    const isPennyPortalDesktop = 'pennyPortalPage' === requestFrom && !isMobile;
                    const isHotel = 'HOTEL' === metadata.type;
                    if (!isHotel) handleLinkClick(`${name}`);
                    if (isHotel || isPennyPortalDesktop) locationMetadataLinkClickHandler({
                        pinsInCurrentLine: [
                            metadata
                        ],
                        targetPin: metadata,
                        setIsMapOpened,
                        checkIn: hotelPayload?.checkIn,
                        checkOut: hotelPayload?.checkOut,
                        isExpressDeal: hotelPayload?.isExpressDeal
                    });
                }
            });
        }
        const action = url.searchParams.get('action');
        const bookType = url.searchParams.get('bookType');
        if ('BOOK' === action && 'HOTEL' === bookType) {
            const rateId = url.searchParams.get('roomRateId');
            return /*#__PURE__*/ jsx(Link, {
                href: "#",
                onClick: handleHotelRoomBookNowClick({
                    rateId,
                    isMobile,
                    cguid: submitChatMessagesPayload?.cguid,
                    rguid: submitChatMessagesPayload?.rguid
                }),
                children: "Book Now"
            });
        }
        if ('BOOK' === action && 'RENTAL_CAR' === bookType) {
            const rateId = url.searchParams.get('carRateId');
            return /*#__PURE__*/ jsx(RentalCarBookNowLink, {
                rateId: rateId,
                isMobile: isMobile,
                cguid: submitChatMessagesPayload?.cguid,
                rguid: submitChatMessagesPayload?.rguid
            });
        }
        if ('DETAIL' === action && 'FLIGHT' === bookType) {
            const rateId = url.searchParams.get('flightRateId');
            return /*#__PURE__*/ jsx(FlightDetailLink, {
                rateId: rateId
            });
        }
    } catch (error) {
        analytics.log({
            label: 'CustomLink',
            message: `Malformed URL detected: ${href}`,
            error: error.message
        });
    }
    return /*#__PURE__*/ jsx(Link, {
        href: href,
        target: "_blank",
        onClick: onClick,
        children: children
    });
};
export { CustomLink };
